var map = {
	"./amplify-amazon-button_5.entry.js": [
		45649,
		5649
	],
	"./amplify-auth-container.entry.js": [
		5327,
		5327
	],
	"./amplify-auth-fields_9.entry.js": [
		80561,
		561
	],
	"./amplify-authenticator.entry.js": [
		89967,
		9967
	],
	"./amplify-button_3.entry.js": [
		2338,
		2338
	],
	"./amplify-chatbot.entry.js": [
		77415,
		7415
	],
	"./amplify-checkbox.entry.js": [
		19029,
		9029
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		79160,
		9160
	],
	"./amplify-container.entry.js": [
		70016,
		16
	],
	"./amplify-federated-buttons_2.entry.js": [
		37925,
		7925
	],
	"./amplify-federated-sign-in.entry.js": [
		33596,
		3596
	],
	"./amplify-form-field_4.entry.js": [
		99386,
		9386
	],
	"./amplify-greetings.entry.js": [
		47632,
		7632
	],
	"./amplify-icon-button.entry.js": [
		49212,
		9212
	],
	"./amplify-icon.entry.js": [
		9285,
		9285
	],
	"./amplify-link.entry.js": [
		49065,
		9065
	],
	"./amplify-nav_2.entry.js": [
		8280,
		8280
	],
	"./amplify-photo-picker.entry.js": [
		26060,
		6060
	],
	"./amplify-picker.entry.js": [
		93559,
		3559
	],
	"./amplify-radio-button_3.entry.js": [
		52025,
		2025
	],
	"./amplify-s3-album.entry.js": [
		59448,
		4708,
		9351,
		9383,
		9448
	],
	"./amplify-s3-image-picker.entry.js": [
		82884,
		4708,
		9351,
		9383,
		2884
	],
	"./amplify-s3-image.entry.js": [
		30438,
		4708,
		9351,
		9383,
		438
	],
	"./amplify-s3-text-picker.entry.js": [
		21836,
		4708,
		9351,
		9383,
		1836
	],
	"./amplify-s3-text.entry.js": [
		57886,
		4708,
		9351,
		9383,
		7886
	],
	"./amplify-select-mfa-type.entry.js": [
		78172,
		8172
	],
	"./amplify-sign-in-button.entry.js": [
		325,
		325
	],
	"./amplify-tooltip.entry.js": [
		87337,
		7337
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 21766;
module.exports = webpackAsyncContext;